import * as React from "react";
import { Query } from "react-apollo";
import { Col } from "reactstrap";
import { TiClipboard } from "react-icons/ti";

// GraphQL
import GetCompanyWorkOrders from "../../../GraphQL/Queries/GetCompanyWorkOrders";

// Presentation/UI
import Loader from "../../../Components/Loader/DotLoader";

// Theme
import { Colors } from "../../../Themes";

import styled from "@emotion/styled";

const SummaryContainer = styled.div`
  display: inline-block;
  & span {
    position: relative;
    top: 15px;
    left: 15px;
    font-size: 1.13em;
  }
  & span.summary-number {
    font-weight: 700;
    font-size: 1.73em;
  }
`;

class WorkOrders extends React.Component<{ companyId: string }> {
  render() {
    const { companyId } = this.props;

    return (
      <Query query={GetCompanyWorkOrders} variables={{ id: companyId }}>
        {({ loading, error, data }) => {
          if (loading) {
            return <Loader />;
          }
          if (error) {
            return <div>There was a problem loading the work orders</div>;
          }

          const workOrders = data.allWorkOrders;
          const numberOfRequests =
            !workOrders || !workOrders.length ? 0 : workOrders.length;

          return (
            <Col xs={12} md={4} lg={4}>
              <SummaryContainer>
                <TiClipboard size="4.75em" color={Colors.cmmsBlue} />
              </SummaryContainer>
              <SummaryContainer>
                <span className="summary-number">{numberOfRequests}</span>
                <br />
                <span>Work Orders</span>
              </SummaryContainer>
            </Col>
          );
        }}
      </Query>
    );
  }
}

export default WorkOrders;



// WEBPACK FOOTER //
// ./src/Containers/Dashboard/DashboardCards/WorkOrders.tsx